module.exports = __webpack_public_path__ + "img/GH-kyujin-top-003.1ec1770b.webp";